import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-display-crisp-client',
  templateUrl: './display-crisp-client.component.html',
  styleUrls: ['./display-crisp-client.component.scss']
})
export class DisplayCrispClientComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
